import { useContext } from "react";
import { Link } from "react-router-dom";
import { LoaderCard } from "../../../common/Loader";
import { getIndependentSymbol, getPercentage, getTimeAgo, translate, translateNumber, translatePercentage } from "../../../../helper";
import { ASSET_HOST_BASE_URL, otherParty, TOP_PARTY_COUNT } from "../../../../config";
import LangContext from "../../../../contexts/LangContext";
import "./index.css";

const PARTY_RANK = {
  NC: 0,
  RSP: 1,
  CPNUML: 2,
  NDP: 3,
  NKP: 4,
};

const getPartyRank = (code) => {
  const normalizedCode = String(code || "").toUpperCase();
  return Object.prototype.hasOwnProperty.call(PARTY_RANK, normalizedCode) ? PARTY_RANK[normalizedCode] : Number.POSITIVE_INFINITY;
};

const sortByPartyPriority = (rows = []) =>
  rows
    .map((row, index) => ({ row, index }))
    .sort((a, b) => {
      const rankA = getPartyRank(a.row.party);
      const rankB = getPartyRank(b.row.party);
      if (rankA !== rankB) return rankA - rankB;

      const voteA = Number(a.row.vote);
      const voteB = Number(b.row.vote);
      if (!Number.isNaN(voteA) && !Number.isNaN(voteB) && voteA !== voteB) {
        return voteB - voteA;
      }

      return a.index - b.index;
    })
    .map(({ row }) => row);

const RegionSummary = (props) => {
  const { lang } = useContext(LangContext);
  const { tab, data, district, parties } = props;

  const regionData = data.map((region) => {
    
    if (!region.result) return [];
    let rData = region;
    rData.total = rData.result.reduce((a, b) => a + b.vote, 0);
    rData.result = sortByPartyPriority(rData.result);

    rData.result = rData.result.sort((a,b) => b.vote - a.vote)
    // console.log(rData.result, 'region is idstrict')
    rData.result = rData.result.filter((a, b) => b < TOP_PARTY_COUNT);
    return rData;
  });

  let updatedAt = new Date("2022-11-20T23:59:59");
  regionData.forEach((r) => {
    if (r.result) {
      r.result.forEach((res) => {
        if (updatedAt < new Date(res.updated_at)) {
          updatedAt = new Date(res.updated_at);
        }
      });
    }
  });

  const regions = district.regions.filter((r) => r.rtype === tab);

  return (
    <section id="sh-region-summary" className="sh-summary-section">
      <div className="container">
        <div className="container-fluid-removed card-removed sh-card-summary">
          <div className="row">
            <div className="col-md-12">
              {/* <span className="float-end">
                {translate("last_updated", lang)}: &nbsp;{translateNumber(getTimeAgo(updatedAt).time, lang)} {translate(getTimeAgo(updatedAt).metrics, lang)} {translate("ago", lang)}
              </span> */}
              {/* <h3>{translate("top_candidates", lang)}</h3> */}
              <h3>निर्वाचन क्षेत्रहरू</h3>
            </div>
            {regions.map((reg, i) => {
              const rData = regionData.find((r) => r && r.id && r.id.toFixed(1) === reg.id.toFixed(1));
              return (
                <div key={i} className="col-xl-4 col-md-6 col-sm-6">
                  <div className="sh-widget-card card">
                    {!props.fetched && <LoaderCard />}
                    <h4 className="text-center">
                      <Link to={"/result/" + props.pid + "/" + district.id + "/" + reg.id.toFixed(0) + "?type=" + tab + "&lang=" + lang}>
                        {translate("ern", lang)} {translateNumber(parseFloat(reg.id.toFixed(1)), lang)}
                      </Link>

                      {rData && <span className={rData.declared ? "sh-count-done" : "sh-counting"}> {rData.declared ? translate("count_done", lang) : rData.result.find((r) => r.vote > 0) ? translate("couting", lang) : ""}</span>}
                    </h4>
                    {rData && rData.result.length > 0 &&
                      rData.result.map((d, j) => {
                        const party = parties.find((par) => par.code === d.party || (d.party.match(/I+\d/) && par.code === "I")) || otherParty;
                        let symbol = party.code.toUpperCase();
                        if (symbol === "I") {
                          symbol = getIndependentSymbol(district.id, reg.id, d.name_en);
                        }
                        const gender = d.gender ? d.gender : "O";
                        const candidateImageUrl =
                          d.candidatephoto && d.candidatephoto.trim() !== ""
                            ? d.candidatephoto
                            : `https://result.election.gov.np/Images/Candidate/${d.candidateid}.jpg`;

                        return (
                          <div key={j}>
                            <div className="sh-candidate-info">
                              <div class="sh-candidate-info-section">
                                <div className={"sh-candidate-photo-wrapper" + (d.elected ? " sh-highlight-rotate" : "")}>
                                  <img
                                    src={ASSET_HOST_BASE_URL + "/images/parties/" + symbol + ".png"}
                                    alt={party.code.toUpperCase()}
                                    onError={({ currentTarget }) => {
                                      currentTarget.onerror = null; // prevents looping
                                      currentTarget.src = ASSET_HOST_BASE_URL + "/images/parties/O.png";
                                    }}
                                    className="pull-left sh-party-symbol-inner"
                                    width="24px"
                                    height="24px"
                                  />
                                  <img
                                    src={candidateImageUrl}
                                    alt={party.code.toUpperCase()}
                                    onError={({ currentTarget }) => {
                                      currentTarget.onerror = null; // prevents looping
                                      currentTarget.src = ASSET_HOST_BASE_URL + "/images/candidates/dummy-" + gender + ".jpg";
                                    }}
                                    className="pull-left sh-candidate-photo"
                                    width="50px"
                                    height="50px"
                                    style={d.elected ? { border: "1px solid " + party.color, padding: "2px" } : {}}
                                  />
                                </div>
                                <div className="sh-candidate-name">
                                  {<Link to={"/candidates/profile/" + d.cid + "?lang=" + lang}>{d["name_" + lang]}</Link>}
                                  <br />
                                  <span className="sh-gender-age-party">
                                    <Link to={"/candidates/" + party.code + "?lang=" + lang}>{party["short_name_" + lang] ? party["short_name_" + lang] : party["name_" + lang]}</Link> - {translate(d.gender === "M" ? "male" : d.gender === "F" ? "female" : "other", lang) + ", " + translateNumber(d.age, lang) + " " + translate("years", lang)}
                                  </span>
                                </div>
                              </div>
                              
                              <div class="sh-banner-winner-section">
                                {d.elected && rData.declared && <span className="sh-banner-winner">{ <img src={ "https://assets.deshsanchar.com/wp-content/uploads/2026/02/25194001/checklist2.png"} alt="winner" width="20px" height="20px" />}<span>{translate("elected", lang)}</span></span>}
                                <span className="sh-winner data">
                                  <span>मत</span> {translateNumber(d.vote, lang)}
                                </span>
                              </div>
                              
                            </div>

                            <div className="progress">
                              <div className={"progress-bar progress-bar-striped" + (rData.declared ? "" : " progress-bar-animated")} role="progressbar" style={{ width: getPercentage(d.vote, rData.total), backgroundColor: party.color }}>
                                {translatePercentage(d.vote, rData.total, lang)}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    <div className="sh-view-all">
                      <span>
                        <Link to={"/result/" + props.pid + "/" + district.id + "/" + reg.id.toFixed(0) + "?type=" + tab + "&lang=" + lang}>{translate("view_all", lang)}</Link>
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegionSummary;
